var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', [_vm.loading ? _c('div', {
    staticClass: "vh-100 d-flex flex-column gap-5 bg-light justify-content-center align-items-center"
  }, [_c('div', {
    staticClass: "mb-3"
  }, _vm._l(3, function (i) {
    return _c('b-spinner', {
      key: i,
      staticClass: "mr-1",
      attrs: {
        "small": "",
        "label": "Small Spinner",
        "type": "grow"
      }
    });
  }), 1), _c('h3', [_vm._v(_vm._s(_vm.$t("checkout.placingOrder")))])]) : _vm._e(), _vm.isFailed ? _c('h3', [_vm._v(_vm._s(_vm.$t("checkout.wentWrong")))]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }